import React, {Component} from "react";

class MaterialDetail extends Component {

    render() {
        return (
            <div className="container-fluid">
                <p> FR-4標準Tg140Cを使用しています。それ以外の材質は対応しておりません。
                </p>
                <p> 詳しくはFR-4 Material.pdfをご確認下さい。
                </p>

            </div>
        );
    }
}

export default MaterialDetail;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/MaterialDetail.js